import axios from 'axios';
import { API_URL, API_GATEWAY_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Отдельный экземпляр axios для авторизационных запросов
const gatewayApi = axios.create({
  baseURL: API_GATEWAY_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Добавляем токен к каждому запросу
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  console.log(`API запрос к ${config.url}. Токен ${token ? 'присутствует' : 'отсутствует'}`);
  
  if (token) {
    // Всегда используем Bearer формат
    config.headers.Authorization = `Bearer ${token}`;
    console.log('api interceptors.request Заголовок Authorization для API:', `Bearer ${token.substring(0, 20)}...`);
  } else {
    console.log('api interceptors.request ВНИМАНИЕ: Токен отсутствует при выполнении API запроса');
  }
  return config;
});

// Добавляем токен к авторизационным запросам
gatewayApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  console.log('authApi interceptors.request token', token);
  console.log(`authApi interceptors.request запрос к ${config.url}. Токен ${token ? 'присутствует' : 'отсутствует'}`);
  
  // Добавляем домен клиента в заголовки запроса
  const clientDomain = window.location.origin;
  config.headers['X-Client-Domain'] = clientDomain;
  console.log('Заголовок X-Client-Domain для Auth API:', clientDomain);
  
  if (token) {
    // Всегда используем Bearer формат
    config.headers.Authorization = `Bearer ${token}`;
    console.log('Заголовок Authorization для Auth API:', `Bearer ${token.substring(0, 20)}...`);
  } else {
    console.log('ВНИМАНИЕ: Токен отсутствует при выполнении Auth запроса');
  }
  return config;
});

// Глобальная переменная для отслеживания запросов обновления токена
let isRefreshing = false;
let failedQueue = [];

// Обработка запросов, которые были отложены до обновления токена
const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

// Обработка ошибок аутентификации в общем API
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Если ошибка 401 и запрос не является запросом на обновление токена
    // Excluded endpoints: login, logout, refresh-token, exchange-token, google OAuth
    const excludedEndpoints = ['refresh-token', 'login', 'logout', 'exchange-token', 'google'];
    const isExcluded = excludedEndpoints.some(endpoint => originalRequest.url?.includes(endpoint));
    
    if (error.response?.status === 401 && 
        !originalRequest._retry && 
        !isExcluded) {
      
      if (isRefreshing) {
        // Если процесс обновления токена уже идет, добавляем запрос в очередь
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      
      // Помечаем, что началось обновление токена
      originalRequest._retry = true;
      isRefreshing = true;
      
      try {
        console.log('Используем authAPI.refreshToken для обновления токена');
        
        // Вызываем метод refreshToken из authAPI, который сам сохраняет токен в localStorage
        await authAPI.refreshToken();
        
        console.log('Ответ от сервера обновления токена получен');
        
        // Получаем токен из localStorage, так как refreshToken уже сохранил его там
        const newToken = localStorage.getItem('token');
        
        if (newToken) {
          // Обновляем заголовок текущего запроса
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          
          // Обрабатываем очередь запросов
          processQueue(null, newToken);
          
          // Повторно выполняем оригинальный запрос
          return api(originalRequest);
        } else {
          throw new Error('Не удалось получить новый токен из localStorage после обновления');
        }
      } catch (refreshError) {
        // Обрабатываем ошибку обновления токена
        console.error('Ошибка при обновлении токена:', refreshError.message);
        if (refreshError.response) {
          console.error('Детали ошибки:', {
            status: refreshError.response.status,
            data: refreshError.response.data
          });
        }

        processQueue(refreshError, null);

        // Разлогиниваем только на явный 401 — единственный ответ, который
        // значит «refresh-кука мертва». На 5xx, таймауте и обрыве сети сессия
        // жива, и выкидывать человека из-за временной проблемы нельзя.
        if (refreshError?.response?.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');

          // Если не на странице логина или регистрации, перенаправляем
          const currentPath = window.location.pathname;
          if (currentPath !== '/login' && currentPath !== '/register') {
            localStorage.setItem('redirectAfterLogin', currentPath);
            window.location.href = '/login';
          }
        }

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    
    // Прочие ошибки с ответом сервера
    if (error.response) {
      console.error('Ошибка API:', error.response.status, error.response.data);
    } else if (error.request) {
      // Ошибка запроса (нет ответа от сервера)
      console.error('Ошибка запроса (нет ответа от сервера):', error.request);
    } else {
      // Другие ошибки
      console.error('Ошибка:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Обработка ошибок аутентификации в авторизационном API
gatewayApi.interceptors.response.use(
  (response) => {
    // Логирование успешных ответов от сервиса авторизации для отладки
    if (response.config.url && 
       (response.config.url.includes('/login') || 
        response.config.url.includes('/register') || 
        response.config.url.includes('/validate-token'))) {
      console.log('Успешный ответ от сервиса авторизации:', response.config.url, response.data);
    }
    return response;
  },
  async (error) => {
    // Логируем запрос, который вызвал ошибку
    console.log('Ошибка в запросе authApi:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message
    });

    const originalRequest = error.config;
    
    // Если ошибка 401 и запрос не является запросом на обновление токена
    // Excluded endpoints: login, logout, refresh-token, exchange-token, google OAuth
    const excludedEndpoints = ['refresh-token', 'login', 'logout', 'exchange-token', 'google'];
    const isExcluded = excludedEndpoints.some(endpoint => originalRequest.url?.includes(endpoint));
    
    if (error.response?.status === 401 && 
        !originalRequest._retry && 
        !isExcluded) {
      
      if (isRefreshing) {
        // Если процесс обновления токена уже идет, добавляем запрос в очередь
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            return gatewayApi(originalRequest);
          })
          .catch(err => {
            return Promise.reject(err);
          });
      }
      
      // Помечаем, что началось обновление токена
      originalRequest._retry = true;
      isRefreshing = true;
      
      try {
        console.log('AuthApi: Используем authAPI.refreshToken для обновления токена');
        
        // Вызываем метод refreshToken из authAPI, который сам сохраняет токен в localStorage
        await authAPI.refreshToken();
        
        console.log('AuthApi: Ответ от сервера обновления токена получен');
        
        // Получаем токен из localStorage, так как refreshToken уже сохранил его там
        const newToken = localStorage.getItem('token');
        
        if (newToken) {
          // Обновляем заголовок текущего запроса
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          
          // Обрабатываем очередь запросов
          processQueue(null, newToken);
          
          // Повторно выполняем оригинальный запрос
          return gatewayApi(originalRequest);
        } else {
          throw new Error('Не удалось получить новый токен из localStorage после обновления');
        }
      } catch (refreshError) {
        // Обрабатываем ошибку обновления токена
        console.error('AuthApi: Ошибка при обновлении токена:', refreshError.message);
        if (refreshError.response) {
          console.error('AuthApi: Детали ошибки:', {
            status: refreshError.response.status,
            data: refreshError.response.data
          });
        }

        processQueue(refreshError, null);

        // Разлогиниваем только на явный 401 — единственный ответ, который
        // значит «refresh-кука мертва». На 5xx, таймауте и обрыве сети сессия
        // жива, и выкидывать человека из-за временной проблемы нельзя.
        if (refreshError?.response?.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');

          // Если не на странице логина или регистрации, перенаправляем
          const currentPath = window.location.pathname;
          if (currentPath !== '/login' && currentPath !== '/register') {
            localStorage.setItem('redirectAfterLogin', currentPath);
            window.location.href = '/login';
          }
        }

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
    
    // Прочие ошибки с ответом сервера
    if (error.response) {
      console.error('Ошибка authApi:', error.response.status, error.response.data);
    } else if (error.request) {
      // Ошибка запроса (нет ответа от сервера)
      console.error('Ошибка запроса authApi (нет ответа от сервера):', error.request);
    } else {
      // Другие ошибки
      console.error('Ошибка authApi:', error.message);
    }
    
    return Promise.reject(error);
  }
);

// Создаем удобный метод для формирования URL с защитой от двойных слешей
export const buildApiUrl = (path) => {
  // Удаляем начальные и конечные слеши
  const cleanPath = path.replace(/^\/+|\/+$/g, '');
  return `${API_URL}/${cleanPath}`;
};

// Экспортируем функцию для установки токена, которая может использоваться для восстановления сессии
export const setAuthToken = (tokens, user) => {
  if (tokens && tokens.accessToken) {
    localStorage.setItem('token', tokens.accessToken);
    // Refresh токен больше не сохраняется в localStorage
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  } else {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

// Аутентификация
export const authAPI = {
  register: async (data) => {
    try {
      console.log('Отправка запроса регистрации в auth service');
      const response = await gatewayApi.post('/auth/register', data, {
        withCredentials: true // Для получения cookie от сервера
      });
      console.log('Ответ регистрации получен:', response.data);
      
      // Сохраняем только access токен в localStorage
      if (response.data && response.data.tokens) {
        localStorage.setItem('token', response.data.tokens.accessToken);
        
        if (response.data.user) {
          localStorage.setItem('user', JSON.stringify(response.data.user));
        }
      }
      
      return response;
    } catch (error) {
      console.error('Ошибка при регистрации:', error);
      throw error;
    }
  },
  login: async (data) => {
    try {
      console.log('Отправка запроса логина в auth service');
      const response = await gatewayApi.post('/auth/login', data, {
        withCredentials: true // Для получения cookie от сервера
      });
      console.log('Ответ логина получен:', response.data);
      
      const userData = response.data;
      // Сохраняем только access токен в localStorage
      if (userData && userData.tokens) {
        localStorage.setItem('token', userData.tokens.accessToken);
        
        if (userData.user) {
          localStorage.setItem('user', JSON.stringify(userData.user));
        }
      }
      
      return response;
    } catch (error) {
      console.error('Ошибка при логине:', error);
      throw error;
    }
  },
  logout: async () => {
    try {
      console.log('Отправка запроса выхода в auth service');
      await gatewayApi.post('/auth/logout', {}, {
        withCredentials: true // Для передачи cookie серверу
      });
    } catch (error) {
      console.error('Ошибка при выходе из системы:', error);
    } finally {
      // Удаляем данные аутентификации из localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },
  refreshToken: async () => {
    try {
      // Определяем URL для обновления токена
      let refreshTokenUrl = '/auth/refresh-token';
      
      console.log('Вызов метода refreshToken с URL:', refreshTokenUrl);
      const response = await gatewayApi.post(refreshTokenUrl, {}, {
        withCredentials: true // Для передачи cookie
      });
      console.log('Ответ от сервера обновления токена:', response.data);
      
      if (response.data) {
        let newToken;
        
        // Учитываем разные структуры ответа
        const userData = response.data.data || response.data;
        
        // Обрабатываем разные форматы ответа
        if (userData.tokens && userData.tokens.accessToken) {
          newToken = userData.tokens.accessToken;
        } else if (userData.accessToken) {
          newToken = userData.accessToken;
        } else if (userData.token) {
          newToken = userData.token;
        }
        
        if (newToken) {
          localStorage.setItem('token', newToken);
          console.log('Обновлен токен из refreshToken метода');
          
          return response;
        }
      }
      
      throw new Error('Не удалось получить новый токен');
    } catch (error) {
      console.error('Ошибка обновления токена в методе refreshToken:', error);
      // Из системы выходим только если рефреш явно вернул 401
      // При сетевых ошибках, 5xx, таймауте — данные авторизации не трогаем
      if (error?.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
      throw error;
    }
  },
  getProfile: () => {
    console.log('Запрос профиля пользователя');
    return gatewayApi.get('/auth/profile');
  },
  updateProfile: (formData) => gatewayApi.put('/auth/profile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  updateProfileSettings: (formData) => api.put('/auth/profile', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  changePassword: (passwordData) => gatewayApi.post('/auth/change-password', passwordData),
  validateToken: () => {
    console.log('Запрос валидации токена');
    return gatewayApi.get('/auth/validate-token');
  },
  // Google OAuth login
  loginWithGoogle: () => {
    const redirectUri = `${window.location.origin}/oauth-callback`;
    const googleAuthUrl = `${process.env.REACT_APP_AUTH_SERVICE_URL}/api/auth/google?redirect_uri=${encodeURIComponent(redirectUri)}`;
    window.location.href = googleAuthUrl;
  },
  // Exchange access token for refresh token cookie (for OAuth)
  exchangeToken: async (accessToken) => {
    try {
      console.log('Обмен accessToken на refreshToken cookie');
      const response = await gatewayApi.post('/auth/exchange-token', {}, {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        },
        withCredentials: true
      });
      console.log('✅ RefreshToken cookie установлен успешно');
      return response.data;
    } catch (error) {
      console.error('❌ Ошибка обмена токена:', error);
      throw error;
    }
  },
  // Handle OAuth callback
  handleOAuthCallback: async (accessToken) => {
    try {
      // Get user profile through API Gateway (same as normal login flow)
      const response = await gatewayApi.get('/auth/me');

      return response.data;
    } catch (error) {
      console.error('OAuth callback error:', error);
      throw error;
    }
  },
};

export const profileAPI = {
  getProfile: () => api.get('/auth/profile'),
};
// Курсы
export const coursesAPI = {
  getAll: (params) => gatewayApi.get('/courses-service/courses/with-professions', { params }),
  getAllShort: () => gatewayApi.get('/courses-service/courses', { params: { all: true } }),

  getBySlug: (slug, params) => gatewayApi.get(`/courses-service/courses/${slug}`, { params }),
  getBySlugWithProfessions: (slug, params) => gatewayApi.get(`/courses-service/courses/${slug}/with-professions`, { params }),
  getSimilarByProfessions: (id, params) => gatewayApi.get(`/courses-service/courses/${id}/similar-by-professions`, { params }),
  create: (data) => gatewayApi.post('/courses-service/courses', data),
  createWithImage: (formData) => gatewayApi.post('/courses-service/courses/with-image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  update: (id, data) => gatewayApi.put(`/courses-service/courses/${id}`, data),
  updateWithImage: (id, formData) => gatewayApi.put(`/courses-service/courses/${id}/with-image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  delete: (id) => gatewayApi.delete(`/courses-service/courses/${id}`),
  enroll: (id) => gatewayApi.post(`/courses-service/courses/${id}/enroll`),
  checkEnrollment: (id) => gatewayApi.get(`/courses-service/courses/${id}/enrollment-status`),
  rate: (id, rating) => gatewayApi.post(`/courses-service/courses/${id}/rate`, { rating }),
  getLesson: (courseId, moduleId, lessonId) => 
    gatewayApi.get(`/courses-service/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}/with-professions`),
  updateLesson: (courseId, moduleId, lessonId, lessonData) => 
    gatewayApi.put(`/courses-service/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}`, lessonData),
  completeLesson: (courseId, moduleId, lessonId) => 
    gatewayApi.post(`/courses-service/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}/complete`),
  getBookmarks: (params) => gatewayApi.get('/courses-service/courses/user/bookmarks', { params }),
  toggleBookmark: (courseId) => gatewayApi.post(`/courses-service/courses/${courseId}/bookmark`),
  getUserProgress: () => gatewayApi.get('/courses-service/courses/progress'),
  getCourseProgress: (courseId) => gatewayApi.get(`/courses-service/courses/${courseId}/progress`),
  getCourseStudents: (courseId, params = {}) => gatewayApi.get(`/courses-service/courses/${courseId}/students`, { params }),
  getCourseStudentsStats: (courseId) => gatewayApi.get(`/courses-service/courses/${courseId}/students-stats`),
  getAuthors: (courseId) => gatewayApi.get(`/courses-service/courses/${courseId}/authors`),
  updateModule: (courseId, moduleId, moduleData) => gatewayApi.put(`/courses-service/courses/${courseId}/modules/${moduleId}`, moduleData),
  // Новые методы для раздельного сохранения модулей и уроков
  updateCourseModules: (courseId, modules) => gatewayApi.put(`/courses-service/courses/${courseId}/update-modules`, { modules }),

  // JSON экспорт/импорт
  exportToJson: (id) => gatewayApi.get(`/courses-service/courses/${id}/export-json`),
  importFromJson: (data) =>
    gatewayApi.post(`/courses-service/courses/import-json`, {
      courseData: data.courseData,
      user: data.user,
    }),
  exportModuleToJson: (courseId, moduleId) => gatewayApi.get(`/courses-service/courses/${courseId}/modules/${moduleId}/export-json`),
  exportLessonToJson: (courseId, moduleId, lessonId) => 
    gatewayApi.get(`/courses-service/courses/${courseId}/modules/${moduleId}/lessons/${lessonId}/export-json`),
  exportTestToJson: (testId) => gatewayApi.get(`/courses-service/courses/tests/${testId}/export-json`),
  importLessonToModule: (courseId, moduleId, lessonData) => {
    // Проверка на пустые идентификаторы
    if (!courseId) {
      return Promise.reject(new Error('Отсутствует ID курса. Невозможно импортировать урок.'));
    }
    
    if (!moduleId) {
      return Promise.reject(new Error('Отсутствует ID модуля. Невозможно импортировать урок.'));
    }
    
    return gatewayApi.post(`/courses-service/courses/${courseId}/modules/${moduleId}/import-lesson-json`, { lessonData });
  },
  importLessonsArrayToModule: (courseId, moduleId, lessonsArray) => {
    // Проверка на пустые идентификаторы
    if (!courseId) {
      return Promise.reject(new Error('Отсутствует ID курса. Невозможно импортировать уроки.'));
    }
    
    if (!moduleId) {
      return Promise.reject(new Error('Отсутствует ID модуля. Невозможно импортировать уроки.'));
    }
    
    if (!Array.isArray(lessonsArray) || lessonsArray.length === 0) {
      return Promise.reject(new Error('Пустой массив уроков или некорректный формат.'));
    }
    
    return gatewayApi.post(`/courses-service/courses/${courseId}/modules/${moduleId}/import-lessons-array`, { lessonsArray });
  },
  importTestsArrayToModule: (courseId, moduleId, testsArray) => {
    // Проверка на пустые идентификаторы
    if (!courseId) {
      return Promise.reject(new Error('Отсутствует ID курса. Невозможно импортировать тесты.'));
    }
    
    if (!moduleId) {
      return Promise.reject(new Error('Отсутствует ID модуля. Невозможно импортировать тесты.'));
    }
    
    if (!Array.isArray(testsArray) || testsArray.length === 0) {
      return Promise.reject(new Error('Пустой массив тестов или некорректный формат.'));
    }
    
    return gatewayApi.post(`/courses-service/courses/${courseId}/modules/${moduleId}/import-tests-array`, { testsArray });
  },
};

// API для модулей
export const modulesAPI = {
  // Получить все модули с фильтрацией
  getAll: (params) => gatewayApi.get('/courses-service/modules', { params }),
  
  // Получить модуль по ID или slug
  getById: (id) => gatewayApi.get(`/courses-service/modules/${id}/with-professions`),
  
  // Создать новый модуль
  create: (moduleData) => gatewayApi.post('/courses-service/modules', moduleData),

  // Создать новый модуль с изображением
  createWithImage: (formData) => gatewayApi.post('/courses-service/modules/with-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),

  // Обновить модуль
  update: (id, moduleData) => gatewayApi.put(`/courses-service/modules/${id}`, moduleData),

  // Обновить модуль с изображением
  updateWithImage: (id, formData) => gatewayApi.put(`/courses-service/modules/${id}/with-image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  
  // Проверить возможность удаления модуля
  checkDelete: (id) => gatewayApi.get(`/courses-service/modules/${id}/delete-check`),
  
  // Удалить модуль (с подтверждением)
  delete: (id, confirmDelete = false, forceDelete = false) => 
    gatewayApi.delete(`/courses-service/modules/${id}`, { 
      data: { confirmDelete, forceDelete } 
    }),
  
  // Удалить урок из модуля (отвязать)
  removeLessonFromModule: (moduleId, lessonId) => 
    gatewayApi.delete(`/courses-service/modules/${moduleId}/lessons/${lessonId}`),
  
  // Добавить модуль в курс
  addToCourse: (id, courseId, order) => 
    gatewayApi.post(`/courses-service/modules/${id}/add-to-course`, { courseId, order }),
  
  // Удалить модуль из курса
  removeFromCourse: (id, courseId) =>
    gatewayApi.delete(`/courses-service/modules/${id}/remove-from-course`, { data: { courseId } }),
  
  // Получить модули автора
  getByAuthor: (authorId, params) => 
    gatewayApi.get(`/courses-service/modules/author/${authorId}`, { params }),
  
  // Экспорт модуля в JSON
  exportToJson: (id) => gatewayApi.get(`/courses-service/modules/${id}/export-json`),
  
  // Импорт модуля из JSON
  importFromJson: (moduleData) => gatewayApi.post('/courses-service/modules/import-json', { moduleData }),
};

// Тесты
export const testsAPI = {
  getById: (id) => api.get(`/tests/${id}`),
  getByContext: (testId, courseSlug, moduleSlug, lessonSlug) =>
    api.get(`/tests/${testId}/context/${courseSlug}/${moduleSlug}/${lessonSlug}`),
  getAll: () => api.get('/tests'),
  create: (data) => api.post('/tests', data),
  submit: (id, answers, timeSpent, courseId) => api.post(`/tests/${id}/submit`, { answers, timeSpent, courseId }),
  getResults: (id) => api.get(`/tests/${id}/results`),
  update: (id, data) => api.put(`/tests/${id}`, data),
  delete: (id) => api.delete(`/tests/${id}`),
  // Новые методы для работы с результатами тестов
  getUserResults: (params) => api.get('/tests/results/user', { params }),
  getResultDetail: (id) => api.get(`/tests/results/${id}`),
  getStatistics: () => api.get('/tests/statistics'),
  getUserResultsStatistics: () => api.get('/tests/results/user/statistics'),
  // Метод для создания теста в модуле
  createForModule: (moduleId, data) => api.post(`/tests/module/${moduleId}`, data),
  // Метод для получения тестов модуля
  getByModuleId: (moduleId) => api.get(`/tests/module/${moduleId}`),
  // Добавляем метод для импорта массива тестов в модуль
  importTestsArrayToModule: async (courseId, moduleId, testsArray) => {
    if (!courseId) {
      throw new Error('ID курса не указан');
    }
    if (!moduleId) {
      throw new Error('ID модуля не указан');
    }
    if (!testsArray || !Array.isArray(testsArray) || testsArray.length === 0) {
      throw new Error('Массив тестов пуст или не предоставлен');
    }

    console.log('API: Отправка запроса на импорт тестов', { 
      courseId, 
      moduleId, 
      testsCount: testsArray.length 
    });
    
    try {
      const response = await api.post(
        `/courses/${courseId}/modules/${moduleId}/import-tests-array`,
        { testsArray }
      );
      
      console.log('API: Получен ответ от сервера импорта тестов', response.data);
      return response;
    } catch (error) {
      console.error('API: Ошибка при импорте тестов', error);
      throw error;
    }
  },
  // Метод для получения навигационной информации после завершения теста
  getNavigation: (courseSlug, moduleSlug, testId) => api.get(`/tests/${courseSlug}/${moduleSlug}/${testId}/navigation`),
  // Метод для получения информации о тесте (курс и модуль)
  getTestInfo: (testId) => api.get(`/tests/${testId}/info`),
  // Відкриті відповіді — перевірка
  getPendingReviews: (params) => api.get('/tests/results/pending', { params }),
  reviewAnswer: (resultId, answerIndex, data) => api.put(`/tests/results/${resultId}/answers/${answerIndex}/review`, data),
  regenerateAIReview: (resultId, answerIndex) => api.post(`/tests/results/${resultId}/answers/${answerIndex}/ai-review`)
};

// Достижения
export const achievementsAPI = {
  getAll: (params = {}) => api.get('/achievements', { params }),
  getUserAchievements: (userId) => api.get(`/achievements/user/${userId}`),
  create: (data) => api.post('/achievements', data),
  check: () => api.post('/achievements/check'),
  getStats: () => api.get('/achievements/stats'),
  update: (id, data) => api.put(`/achievements/${id}`, data),
  delete: (id) => api.delete(`/achievements/${id}`),
};

// Значки
export const badgesAPI = {
  getAll: () => api.get('/badges'),
  getUserBadges: (userId) => api.get(`/badges/user/${userId}`),
  check: () => api.post('/badges/check'),
  getById: (id) => api.get(`/badges/${id}`),
  // Создание, обновление и удаление значков
  create: (badgeData) => api.post('/badges', badgeData),
  update: (id, badgeData) => api.put(`/badges/${id}`, badgeData),
  delete: (id) => api.delete(`/badges/${id}`),
  // Загрузка изображения значка
  uploadImage: (imageFile) => {
    const formData = new FormData();
    formData.append('badgeImage', imageFile);
    return api.post('/badges/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // Проверка и выдача значков
  runCheck: (data) => api.post('/badges/run-check', data),
  // checkEligibility: (userId) => api.get(`/badges/check-eligibility/${userId}`),
  // Аналитика
  getPopularityStats: () => api.get('/badges/analytics/popularity'),
  getDifficultyStats: () => api.get('/badges/analytics/difficulty'),
};

// Серии значков
export const badgeSeriesAPI = {
  getAll: () => api.get('/badge-series'),
  getById: (id) => api.get(`/badge-series/${id}`),
  getUserBadgeSeries: (userId) => api.get(`/badge-series/user/${userId}`),
  create: (seriesData) => api.post('/badge-series', seriesData),
  update: (id, seriesData) => api.put(`/badge-series/${id}`, seriesData),
  delete: (id) => api.delete(`/badge-series/${id}`),
  // Загрузка изображения серии
  uploadImage: (imageFile) => {
    const formData = new FormData();
    formData.append('seriesImage', imageFile);
    return api.post('/badge-series/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // Прогресс и награды
  getProgress: (seriesId) => api.get(`/badge-series/${seriesId}/progress`),
  getUserProgress: (userId) => api.get(`/badge-series/user/${userId}`),
  awardSeriesReward: (seriesId, userId) => api.post(`/badge-series/${seriesId}/award`, { userId }),
  // Проверка серий
  runSeriesCheck: (data) => api.post('/badges/run-series-check', data),
};

// Форум
export const forumAPI = {
  // Get all topics with filtering - using search endpoint with enhanced parameters
  getAllTopics: (params = {}) => {
    const { search, courseId, lessonId, page, limit, sortBy } = params;
    const queryParams = {};

    if (search) queryParams.search = search;
    if (courseId) queryParams.courseId = courseId;
    if (lessonId) queryParams.lessonId = lessonId;
    if (page) queryParams.page = page;
    if (limit) queryParams.limit = limit;
    if (sortBy) queryParams.sortBy = sortBy;

    // Use search endpoint with search parameter
    return api.get('/forum/', { params: queryParams });
  },
  getTopicById: (topicId) => api.get(`/forum/topics/${topicId}`),
  createTopic: (data) => api.post('/forum/topics', data),
  addComment: (topicId, data) => api.post(`/forum/topics/${topicId}/comments`, data),
  like: (type, id) => api.post(`/forum/${type}/${id}/like`),
  dislike: (type, id) => api.post(`/forum/${type}/${id}/dislike`),
  getStatistics: () => api.get('/forum/statistics'),
  getUserActivity: (userId) => api.get(`/forum/user/${userId}/activity`),
};

// Рейтинг (Leaderboard)
export const leaderboardAPI = {
  getLeaderboard: (params) => api.get('/leaderboard', { params }),
  getUserRanking: (userId, range = 2) => api.get(`/leaderboard/user/${userId}?range=${range}`),
  getCompetitions: (params) => api.get('/leaderboard/competitions', { params }),
  adminUpdateLeaderboard: () => api.post('/leaderboard/update'),
  getCompetitionDetails: (id) => api.get(`/leaderboard/competitions/${id}`),
  joinCompetition: (id) => api.post(`/leaderboard/competitions/${id}/join`),
  createCompetition: (data) => api.post('/leaderboard/competitions', data),
  createChallenge: (data) => api.post('/leaderboard/challenges', data),
  getUserChallenges: (params = {}) => api.get('/leaderboard/challenges', { params }),
  respondToChallenge: (challengeId, response) => api.put(`/leaderboard/challenges/${challengeId}/respond`, { response }),
  // Админские методы
  resetSeasonalExperience: (period) => api.post('/leaderboard/admin/reset-seasonal', { period }),
  updateStreaks: () => api.post('/leaderboard/admin/update-streaks'),
  processInactivity: () => api.post('/leaderboard/admin/process-inactivity'),
  updateCompetitions: () => api.post('/leaderboard/admin/update-competitions'),
  updateRankings: () => api.post('/leaderboard/admin/update-rankings')
};

// Добавляем кэширование для часто используемых запросов
const cache = {
  rankings: new Map(),
  competitions: new Map(), // Добавляем кэш для соревнований
  
  // Функция очистки кэша
  clear: (key) => {
    if (key) {
      if (cache[key]) {
        cache[key].clear();
      }
    } else {
      cache.rankings.clear();
      cache.competitions.clear();
      // Очистка других кэшей
    }
  }
};

// Функция для получения данных с кэшированием
const cachedGet = async (endpoint, params, cacheKey, cacheDuration = 60000) => {
  // Проверка инициализации кэша
  if (!cache[cacheKey]) {
    cache[cacheKey] = new Map();
  }
  
  // Создаем уникальный ключ для кэша на основе параметров
  const paramsString = params ? JSON.stringify(params) : '';
  const fullCacheKey = `${endpoint}:${paramsString}`;
  
  // Проверяем, есть ли данные в кэше и не устарели ли они
  const cachedData = cache[cacheKey].get(fullCacheKey);
  
  if (cachedData && (Date.now() - cachedData.timestamp < cacheDuration)) {
    console.log(`Используем кэшированные данные для ${fullCacheKey}`);
    return cachedData.data;
  }
  
  // Если данных нет в кэше или они устарели, делаем запрос
  console.log(`Запрашиваем свежие данные для ${fullCacheKey}`);
  const response = await api.get(endpoint, { params });
  
  // Кэшируем результат
  cache[cacheKey].set(fullCacheKey, {
    data: response,
    timestamp: Date.now()
  });
  
  return response;
};

// Кэшированный API для лидерборда (чтобы избежать частых запросов)
export const cachedLeaderboardAPI = {
  cache: {}, // Кэш для запросов
  cacheTTL: 60000, // Время жизни кэша в миллисекундах (1 минута)
  timestamps: {}, // Время создания кэша

  // Получение лидерборда с кэшированием
  getLeaderboard: async function(options = {}) {
    const cacheKey = JSON.stringify(options);
    
    // Проверяем, есть ли кэшированные данные и не истек ли их срок
    const now = Date.now();
    if (this.cache[cacheKey] && (now - this.timestamps[cacheKey] < this.cacheTTL)) {
      console.log('Используем кэшированные данные для лидерборда');
      return this.cache[cacheKey];
    }
    
    console.log('Запрашиваем свежие данные лидерборда');
    const response = await leaderboardAPI.getLeaderboard(options);
    
    // Кэшируем результат
    this.cache[cacheKey] = response;
    this.timestamps[cacheKey] = now;
    
    return response;
  },
  
  // Получение рейтинга пользователя с кэшированием
  getUserRanking: async function(userId, range = 2) {
    const cacheKey = `user_${userId}_range_${range}`;
    
    // Проверяем кэш
    const now = Date.now();
    if (this.cache[cacheKey] && (now - this.timestamps[cacheKey] < this.cacheTTL)) {
      console.log('Используем кэшированные данные для рейтинга пользователя');
      return this.cache[cacheKey];
    }
    
    console.log('Запрашиваем свежие данные рейтинга пользователя');
    try {
      const response = await leaderboardAPI.getUserRanking(userId, range);
      console.log('Получен ответ от API:', response && response.data ? 'данные присутствуют' : 'данные отсутствуют', response);
      
      // Проверка на наличие ошибок или пустых данных
      if (!response || !response.data) {
        console.error('Неверный ответ от API, используем мок-данные');
        // Возвращаем пустой массив рейтингов для использования мок-данных
        return { data: { rankings: [] } };
      }
      
      // Проверяем, что данные имеют нужную структуру
      if (!response.data.rankings) {
        console.log('Ответ API не содержит rankings, пытаемся адаптировать данные');
        // Попробуем адаптировать ответ, если формат другой
        if (Array.isArray(response.data)) {
          // Если ответ - это массив, предполагаем, что это массив рейтингов
          response.data = { rankings: response.data };
        } else {
          // Создаем пустой массив рейтингов, если структура непонятна
          response.data.rankings = [];
        }
      }
      
      // Кэшируем результат
      this.cache[cacheKey] = response;
      this.timestamps[cacheKey] = now;
      
      return response;
    } catch (error) {
      console.error('Ошибка при получении данных рейтинга:', error);
      // При ошибке возвращаем пустой результат для активации мок-данных
      return { data: { rankings: [] } };
    }
  },
  
  // Очистка всего кэша
  clearCache: function() {
    this.cache = {};
    this.timestamps = {};
    console.log('Кэш лидерборда очищен');
  },

  // Метод для запроса данных о соревнованиях с кэшированием
  getCompetitions: (status = 'all') => 
    cachedGet('/leaderboard/competitions', { status }, 'competitions', 30000),
  
  joinCompetition: (competitionId) => {
    // При изменении данных очищаем кэш соревнований
    cache.competitions.clear();
    return api.post(`/leaderboard/competitions/${competitionId}/join`);
  },
  
  createCompetition: (competitionData) => {
    // При создании нового соревнования очищаем кэш
    cache.competitions.clear();
    return api.post('/leaderboard/competitions', competitionData);
  },
  
  updateCompetitions: () => {
    // При обновлении данных очищаем кэш
    cache.competitions.clear();
    return api.post('/leaderboard/admin/update-competitions');
  },
};



// Уведомления
export const notificationsAPI = {
  // Получить все уведомления пользователя
  getNotifications: async () => {
    try {
      const res = await api.get('/notifications');
      return res.data;
    } catch (err) {
      console.error('Ошибка получения уведомлений:', err);
      throw err;
    }
  },
  
  // Получить непрочитанные уведомления
  getUnreadNotifications: async () => {
    try {
      const res = await api.get('/notifications/unread');
      return res.data;
    } catch (err) {
      console.error('Ошибка получения непрочитанных уведомлений:', err);
      throw err;
    }
  },
  
  // Получить количество непрочитанных уведомлений
  getUnreadCount: async () => {
    try {
      const res = await api.get('/notifications/count');
      return res.data.count;
    } catch (err) {
      console.error('Ошибка получения количества непрочитанных уведомлений:', err);
      throw err;
    }
  },
  
  // Отметить уведомление как прочитанное
  markAsRead: async (notificationId) => {
    try {
      const res = await api.put(`/notifications/${notificationId}`);
      return res.data;
    } catch (err) {
      console.error('Ошибка при отметке уведомления как прочитанного:', err);
      throw err;
    }
  },
  
  // Отметить все уведомления как прочитанные
  markAllAsRead: async () => {
    try {
      const res = await api.put('/notifications/read-all');
      return res.data;
    } catch (err) {
      console.error('Ошибка при отметке всех уведомлений как прочитанных:', err);
      throw err;
    }
  },
  
  // Удалить уведомление
  deleteNotification: async (notificationId) => {
    try {
      const res = await api.delete(`/notifications/${notificationId}`);
      return res.data;
    } catch (err) {
      console.error('Ошибка при удалении уведомления:', err);
      throw err;
    }
  },
  
  // Удалить все уведомления
  clearAllNotifications: async () => {
    try {
      const res = await api.delete('/notifications');
      return res.data;
    } catch (err) {
      console.error('Ошибка при удалении всех уведомлений:', err);
      throw err;
    }
  }
};

// Пользователи и публичные профили
export const usersAPI = {
  // Получение списка пользователей
  getAll: (params = {}) => gatewayApi.get('/users', { params }),
  
  // Получение пользователя по ID
  getById: (id) => gatewayApi.get(`/users/${id}`),
  
  // Обновление роли пользователя
  updateRole: (id, role) => gatewayApi.patch(`/users/${id}/role`, { role }),
  
  // Блокировка пользователя
  ban: (id, reason) => gatewayApi.patch(`/users/${id}/ban`, { reason }),
  
  // Разблокировка пользователя
  unban: (id) => gatewayApi.patch(`/users/${id}/unban`),
  
  // Обновление статуса активности пользователя
  updateActivity: (id, isActive) => api.patch(`/users/${id}/activity`, { isActive }),
  
  // Обновление данных пользователя
  updateUser: (id, data) => gatewayApi.put(`/users/${id}`, data),
  
  // Удаление пользователя
  deleteUser: (id) => gatewayApi.delete(`/users/${id}`),
  
  // Новые методы для публичного профиля
  getUserProfile: (id) => api.get(`/users/${id}/profile`),
  getUserCourses: (id) => gatewayApi.get(`/courses-service/courses/user/${id}/with-professions?includeProgress=true&searchBy=id`),
  getUserTestResults: (id) => api.get(`/tests/user/${id}/results`),
  
  // Получение завершенных уроков пользователя с пагинацией
  getUserCompletedLessons: (id, params = {}) => api.get(`/users/${id}/completed-lessons`, { params }),
  
  // Синхронизация пользователя по userId/email или создание нового
  syncOrCreateUser: ({ userId, email, username, roles, avatar }) =>
    api.post('/users/sync-or-create', { userId, email, username, roles, avatar }),
    
  // Получение статистики пользователя
  getUserStatistics: (id) => api.get(`/users/${id}/statistics`),

  // Получение прогресса курсов пользователей (для админов)
  getCourseProgress: (params) => api.get('/users/course-progress', { params }),
  getCourseProgressDetail: (userId, courseId) => api.get(`/users/${userId}/course-progress/${courseId}`),
  exportCourseProgress: (params) => api.get('/users/course-progress/export', { params, responseType: 'blob' }),
};

// Резервное копирование базы данных (только для админов)
export const backupAPI = {
  // Получить список всех резервных копий
  getAll: () => api.get('/backup'),
  
  // Создать новую резервную копию
  create: () => api.post('/backup/create'),
  
  // Восстановить базу из резервной копии
  restore: (filename) => api.post(`/backup/restore/${filename}`),
  
  // Загрузить файл резервной копии на сервер
  upload: (file) => {
    const formData = new FormData();
    formData.append('backupFile', file);
    
    return api.post('/backup/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Скачать файл резервной копии (возвращает URL для скачивания)
  getDownloadUrl: (filename) => {
    // Просто используем относительный URL, который всегда будет работать
    return `/uploads/backups/${filename}`;
  },
  
  // Удалить резервную копию
  delete: (filename) => api.delete(`/backup/${filename}`)
};

// API-токены для доступа к API курсов
export const apiTokensAPI = {
  getAll: () => api.get('/tokens'),
  getById: (id) => api.get(`/tokens/${id}`),
  create: (data) => api.post('/tokens', data),
  activate: (id) => api.patch(`/tokens/${id}/activate`),
  deactivate: (id) => api.patch(`/tokens/${id}/deactivate`),
  delete: (id) => api.delete(`/tokens/${id}`)
};

// Учебные дорожки
export const learningPathsAPI = {
  getAll: (params) => gatewayApi.get('/courses-service/learning-paths/with-professions', { params }),
  getById: (id) => gatewayApi.get(`/courses-service/learning-paths/${id}/with-professions`),
  getMyDrafts: (params) => gatewayApi.get('/courses-service/learning-paths/my/drafts/with-professions', { params }),
  getMyPublished: (params) => gatewayApi.get('/courses-service/learning-paths/my/published/with-professions', { params }),
  getMy: (params) => gatewayApi.get('/courses-service/learning-paths/my/all/with-professions', { params }),
  create: (data) => gatewayApi.post('/courses-service/learning-paths', data),
  update: (id, data) => gatewayApi.put(`/courses-service/learning-paths/${id}`, data),
  delete: (id) => gatewayApi.delete(`/courses-service/learning-paths/${id}`),
  addCourse: (id, courseData) => gatewayApi.post(`/courses-service/learning-paths/${id}/courses`, courseData),
  removeCourse: (id, courseId) => gatewayApi.delete(`/courses-service/learning-paths/${id}/courses/${courseId}`),
  // Метод для загрузки изображения
  uploadImage: (imageFile) => {
    const formData = new FormData();
    formData.append('image', imageFile);
    return gatewayApi.post('/courses-service/learning-paths/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // Метод для создания дорожки с изображением
  createWithImage: (pathData, imageFile) => {
    const formData = new FormData();
    
    // Добавляем все поля из pathData в formData
    Object.keys(pathData).forEach(key => {
      // Преобразуем массивы и объекты в JSON-строки
      if (key === 'courses' || key === 'professions' || key === 'mandatory') {
        formData.append(key, JSON.stringify(pathData[key]));
      } else {
        formData.append(key, pathData[key]);
      }
    });

    // Добавляем файл изображения, если он есть
    if (imageFile) {
      formData.append('image', imageFile);
    }

    return gatewayApi.post('/courses-service/learning-paths/with-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // Метод для обновления дорожки с изображением
  updateWithImage: (id, pathData, imageFile) => {
    const formData = new FormData();
    
    // Добавляем все поля из pathData в formData
    Object.keys(pathData).forEach(key => {
      // Преобразуем массивы и объекты в JSON-строки
      if (key === 'courses' || key === 'professions' || key === 'mandatory') {
        formData.append(key, JSON.stringify(pathData[key]));
      } else {
        formData.append(key, pathData[key]);
      }
    });
    
    // Добавляем файл изображения, если он есть
    if (imageFile) {
      formData.append('image', imageFile);
    }
    
    return gatewayApi.put(`/courses-service/learning-paths/${id}/with-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  // Методы для работы с активной дорожкой обучения
  setActive: (pathId) => gatewayApi.post(`/courses-service/learning-paths/${pathId}/set-active`),
  getActive: () => gatewayApi.get('/courses-service/learning-paths/active'),
  getNextCourses: () => gatewayApi.get('/courses-service/learning-paths/active/next-courses'),
  updateActivity: () => gatewayApi.put('/courses-service/learning-paths/active/update-activity'),
  resetActive: () => gatewayApi.delete('/courses-service/learning-paths/active'),
  getMandatoryQueue: () => gatewayApi.get('/courses-service/learning-paths/mandatory/queue'),
};

// Испытания
export const challengesAPI = {
  getAll: () => api.get('/challenges'),
  getById: (id) => api.get(`/challenges/${id}`),
  create: (challengeData) => api.post('/challenges', challengeData),
  update: (id, challengeData) => api.put(`/challenges/${id}`, challengeData),
  delete: (id) => api.delete(`/challenges/${id}`),
};

// Профессии (работа с API Gateway)
export const professionsAPI = {
  // Получение всех профессий
  getAll: (params = {}) => gatewayApi.get('/libraries/professions', { params }),

  // Получение профессии по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/professions/${id}`, { params }),

  // Создание новой профессии
  create: (professionData) => gatewayApi.post('/libraries/professions', professionData),

  // Обновление профессии
  update: (id, professionData) => gatewayApi.put(`/libraries/professions/${id}`, professionData),

  // Удаление профессии
  delete: (id) => gatewayApi.delete(`/libraries/professions/${id}`),
};

// Навыки (работа с API Gateway)
export const skillsAPI = {
  // Получение всех навыков
  getAll: (params = {}) => gatewayApi.get('/libraries/skills', { params }),

  // Получение навыка по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/skills/${id}`, { params }),

  // Создание нового навыка
  create: (skillData) => gatewayApi.post('/libraries/skills', skillData),

  // Обновление навыка
  update: (id, skillData) => gatewayApi.put(`/libraries/skills/${id}`, skillData),

  // Удаление навыка
  delete: (id) => gatewayApi.delete(`/libraries/skills/${id}`),
};

// Ответственности (работа с API Gateway)
export const responsibilitiesAPI = {
  // Получение всех ответственностей
  getAll: (params = {}) => gatewayApi.get('/libraries/responsibilities', { params }),

  // Получение ответственности по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/responsibilities/${id}`, { params }),

  // Создание новой ответственности
  create: (responsibilityData) => gatewayApi.post('/libraries/responsibilities', responsibilityData),

  // Обновление ответственности
  update: (id, responsibilityData) => gatewayApi.put(`/libraries/responsibilities/${id}`, responsibilityData),

  // Удаление ответственности
  delete: (id) => gatewayApi.delete(`/libraries/responsibilities/${id}`),
};

// Инструменты (работа с API Gateway)
export const toolsAPI = {
  // Получение всех инструментов
  getAll: (params = {}) => gatewayApi.get('/libraries/tools', { params }),

  // Получение инструмента по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/tools/${id}`, { params }),

  // Создание нового инструмента
  create: (toolData) => gatewayApi.post('/libraries/tools', toolData),

  // Обновление инструмента
  update: (id, toolData) => gatewayApi.put(`/libraries/tools/${id}`, toolData),

  // Удаление инструмента
  delete: (id) => gatewayApi.delete(`/libraries/tools/${id}`),
};

// Департаменты (работа с API Gateway)
export const departmentsAPI = {
  // Получение всех департаментов
  getAll: (params = {}) => gatewayApi.get('/libraries/department', { params }),
  
  // Получение департамента по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/department/${id}`, { params }),
};

// Статусы (работа с API Gateway)
export const statusesAPI = {
  // Получение всех статусов
  getAll: (params = {}) => gatewayApi.get('/libraries/status', { params }),
  
  // Получение статуса по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/status/${id}`, { params }),
};

// Приоритеты (работа с API Gateway)
export const prioritiesAPI = {
  // Получение всех приоритетов
  getAll: (params = {}) => gatewayApi.get('/libraries/priority', { params }),
  
  // Получение приоритета по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/priority/${id}`, { params }),
};

// Языки (работа с API Gateway)
export const languagesAPI = {
  // Получение всех языков
  getAll: (params = {}) => gatewayApi.get('/libraries/language', { params }),
  
  // Получение языка по ID
  getById: (id, params = {}) => gatewayApi.get(`/libraries/language/${id}`, { params }),
};

// Онбординг
export const onboardingAPI = {
  // Получение всех доступных гидов для пользователя
  getGuides: () => api.get('/onboarding/guides'),
  
  // Получение гидов для конкретной страницы по URL
  getGuidesByUrl: (url) => api.get(`/onboarding/guides/by-url?url=${encodeURIComponent(url)}`),
  
  // Получение гидов для конкретной вкладки на странице
  getGuidesByTab: (url, tabId) => api.get(`/onboarding/guides/by-tab?url=${encodeURIComponent(url)}&tabId=${encodeURIComponent(tabId)}`),
  
  // Получение информации о конкретном гиде
  getGuideById: (guideId) => api.get(`/onboarding/guides/${guideId}`),
  
  // Получение прогресса пользователя по всем гидам
  getProgress: () => api.get('/onboarding/progress'),
  
  // Получение прогресса пользователя по конкретному гиду
  getGuideProgress: (guideId) => api.get(`/onboarding/progress/${guideId}`),
  
  // Обновление прогресса пользователя по конкретному гиду
  updateProgress: (guideId, currentStep) => api.put(`/onboarding/progress/${guideId}`, { currentStep }),
  
  // Отметить гид как завершенный
  completeGuide: (guideId) => api.post(`/onboarding/complete/${guideId}`),
  
  // Перезапустить гид онбординга
  restartGuide: (guideId) => api.post(`/onboarding/restart/${guideId}`),
  
  // Администраторские методы
  admin: {
    // Получить все гиды (для администраторов)
    getAllGuides: () => api.get('/onboarding/admin/guides'),
    
    // Получить конкретный гид (для администраторов)
    getGuideById: (id) => api.get(`/onboarding/admin/guides/${id}`),
    
    // Создать новый гид (для администраторов)
    createGuide: (data) => api.post('/onboarding/admin/guides', data),
    
    // Обновить гид (для администраторов)
    updateGuide: (id, data) => api.put(`/onboarding/admin/guides/${id}`, data),
    
    // Удалить гид (для администраторов)
    deleteGuide: (id) => api.delete(`/onboarding/admin/guides/${id}`),
    
    // Получить аналитику по онбордингу (для администраторов)
    getAnalytics: () => api.get('/onboarding/admin/analytics')
  }
};

// Уроки (новая секция)
export const lessonsAPI = {
  // Получение списка уроков с пагинацией и фильтрацией
  getAll: (params = {}) => {
    // If all=true, set a very large limit to get all lessons
    if (params.all) {
      params.limit = 10000;
      params.page = 1;
    }
    
    console.log('lessonsAPI.getAll params:', params);
    
    return gatewayApi.get('/courses-service/lessons/with-professions', { params });
  },
  
  // Получение моих уроков (всех)
  getMy: async (params = {}) => {
    const { page = 1, limit = 10, search } = params;
    const queryParams = {
      instructor: 'me',
      page,
      limit,
      search: search || undefined
    };
    
    return lessonsAPI.getAll(queryParams);
  },
  
  // Получение только моих черновиков
  getMyDrafts: async (params = {}) => {
    const { page = 1, limit = 10, search } = params;
    const queryParams = {
      instructor: 'me',
      isDraft: true,
      page,
      limit,
      search: search || undefined
    };
    
    return lessonsAPI.getAll(queryParams);
  },
  
  // Получение только моих опубликованных уроков
  getMyPublished: async (params = {}) => {
    const { page = 1, limit = 10, search } = params;
    const queryParams = {
      instructor: 'me',
      isDraft: false,
      page,
      limit,
      search: search || undefined
    };
    
    return lessonsAPI.getAll(queryParams);
  },
  
  // Получение урока по ID
  getById: async (id) => {
    return gatewayApi.get(`/courses-service/lessons/${id}/with-professions`);
  },
  
  // Создание урока
  create: async (lessonData) => {
    return gatewayApi.post('/courses-service/lessons', lessonData);
  },
  
  // Создание урока с изображением
  createWithImage: (formData) => {
    return gatewayApi.post('/courses-service/lessons/with-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Обновление урока
  update: async (id, lessonData) => {
    return gatewayApi.put(`/courses-service/lessons/${id}`, lessonData);
  },
  
  // Обновление урока с изображением
  updateWithImage: (id, formData) => {
    return gatewayApi.put(`/courses-service/lessons/${id}/with-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }, 
   // Удаление урока
  delete: async (id) => {
    return gatewayApi.delete(`/courses-service/lessons/${id}`);
  },
  
  // Получение курсов, в которых используется урок
  getCourses: async (id) => {
    return gatewayApi.get(`/courses-service/lessons/${id}/courses`);
  },

  // Получение модулей, в которых используется урок
  getModules: async (id) => {
    return gatewayApi.get(`/courses-service/lessons/${id}/modules`);
  },
  
  // Методы для запросов на изменение уроков
  createChangeRequest: async (lessonId, data) => {
    return gatewayApi.post(`/courses-service/lessons/${lessonId}/change-requests`, data);
  },
  
  getLessonChangeRequests: async (lessonId, params = {}) => {
    const { page = 1, limit = 10, status } = params;
    let url = `/courses-service/lessons/${lessonId}/change-requests`;
    const queryParams = [];
    
    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);
    if (status) queryParams.push(`status=${status}`);
    
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    
    return gatewayApi.get(url);
  },
  
  getUserChangeRequests: async (params = {}) => {
    const { page = 1, limit = 10, status } = params;
    let url = '/courses-service/lessons/change-requests/my';
    const queryParams = [];
    
    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);
    if (status) queryParams.push(`status=${status}`);
    
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    
    return gatewayApi.get(url);
  },
  
  getAllChangeRequests: async (params = {}) => {
    const { page = 1, limit = 10, status } = params;
    let url = '/courses-service/lessons/change-requests';
    const queryParams = [];
    
    if (page) queryParams.push(`page=${page}`);
    if (limit) queryParams.push(`limit=${limit}`);
    if (status) queryParams.push(`status=${status}`);
    
    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }
    
    return gatewayApi.get(url);
  },
  
  getChangeRequestById: async (requestId) => {
    return gatewayApi.get(`/courses-service/lessons/change-requests/${requestId}`);
  },
  
  processChangeRequest: async (requestId, data) => {
    return gatewayApi.put(`/courses-service/lessons/change-requests/${requestId}`, data);
  },
  
  cancelChangeRequest: async (requestId) => {
    // Для пользователей используем my endpoint; админы могут использовать общий
    return gatewayApi.delete(`/courses-service/lessons/change-requests/my/${requestId}`);
  },

  // Пользовательские действия над своими запросами
  getMyChangeRequestById: async (requestId) => {
    return gatewayApi.get(`/courses-service/lessons/change-requests/my/${requestId}`);
  },
  updateMyChangeRequest: async (requestId, data) => {
    return gatewayApi.put(`/courses-service/lessons/change-requests/my/${requestId}`, data);
  },
  
  // Сохранение заметок к уроку
  saveNotes: async (lessonId, notes) => {
    return gatewayApi.post(`/courses-service/lessons/${lessonId}/notes`, { notes });
  },
  
  // Сохранение позиции чтения урока
  saveReadingPosition: async (lessonId, position) => {
    return gatewayApi.post(`/courses-service/lessons/${lessonId}/position`, { position });
  },
  
  // Переключение закладки урока
  toggleBookmark: async (lessonId) => {
    return gatewayApi.post(`/courses-service/lessons/${lessonId}/bookmark`);
  },

  // Универсальный метод для создания или обновления урока с привязкой к модулю
  // Передает ID урока в теле запроса, сервер сам определяет операцию
  createOrUpdateAndAssignToModule: async (lessonData) => {
    return gatewayApi.post('/courses-service/lessons/assign-to-module', lessonData);
  },

  // Универсальный метод для создания или обновления урока с изображением и привязкой к модулю
  // Передает ID урока в FormData, сервер сам определяет операцию
  createOrUpdateWithImageAndAssignToModule: (formData) => {
    return gatewayApi.post('/courses-service/lessons/assign-to-module/with-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

};

export default api; 
